import { useContext, useEffect, useState } from "react"
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { ToastContext } from "../../../../context/ToastContext";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-regular-svg-icons";

export const usePriorities = () => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [visible, setVisible] = useState({ show: false });
    const [loader, setLoader] = useState({ btn: false });
    const [fieldValues, setFieldValues] = useState({ color: "#0000" });
    const [rowData, setRowData] = useState([])

    const formJson = [
        {
            label: "Name",
            name: "priority_name",
            col: "12",
            type: "text",
            required: true,
        },
        {
            label: "Criticality",
            name: "criticality",
            col: "6",
            type: "text",
            required: true,
        },
        {
            label: "Order",
            name: "order_number",
            col: "6",
            type: "number",
            required: true,
        },
        {
            label: "Description",
            name: "description",
            col: "12",
            type: "text",
            required: false,
        },
        // {
        //     label: "Icon",
        //     name: "icon",
        //     col: "6",
        //     type: "file",
        //     required: true,
        // },
    ]

    const columns = [
        {
            key: "order",
            label: "Order",
            style: { width: "10%" },
            render: (row) => (
                <div className="d-flex align-items-center gap-2 py-1">
                    <div
                        className="bg-light rounded d-flex align-items-center justify-content-center"
                        style={{ width: "24px", height: "24px", border: "1px solid #edf2f7" }}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-grip-vertical" className="text-muted" style={{ fontSize: '10px' }} />
                    </div>
                    <span className=" " >{row.order_number || '0'}</span>
                </div>
            )
        },
        {
            key: "name",
            label: "Name",
            style: { width: "20%" },
            render: (row) => (
                <span className="  text-truncate" >
                    {row.priority_name}
                </span>
            )
        },
        {
            key: "description",
            label: "Description",
            style: { width: "30%" },
            render: (row) => (
                <small
                    className="text-truncate fw-semibold d-block"
                    style={{ fontSize: '11px', color: "#9faab6" }}
                    title={row.description}
                >
                    {row.description || "-"}
                </small>
            )
        },
        {
            key: "color",
            label: "Color",
            style: { width: "10%" },
            render: (row) => (
                <div className="d-flex align-items-center gap-2">
                    <div
                        style={{
                            width: '14px',
                            height: '14px',
                            borderRadius: '4px',
                            backgroundColor: row.status_color || '#cbd5e0',
                            border: '1px solid rgba(0,0,0,0.1)'
                        }}
                    />
                    <span style={{ fontSize: '10px' }} className="text-uppercase text-secondary">
                        {row.status_color || '#N/A'}
                    </span>
                </div>
            )
        },
        {
            key: "schemes",
            label: "Schemes",
            style: { width: "15%" },
            render: (row) => (
                <div className="d-flex flex-wrap gap-1 py-1">
                    {row?.field_configuration_scheme_name && (
                        <div
                            style={{
                                borderRadius: "4px",
                                border: "1px solid #dbeafe",
                                fontSize: "10px",
                                backgroundColor: "#f0f7ff"
                            }}
                            className="d-inline-flex align-items-center px-2 py-1 gap-2 text-primary fw-semibold text-truncate"
                        >
                            <FontAwesomeIcon icon="fa-solid fa-link" style={{ fontSize: '9px' }} />
                            {row?.field_configuration_scheme_name}
                        </div>
                    )}
                </div>
            )
        },
        {
            key: "actions",
            label: "Actions",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "15%" },
            render: (row) => {
                return (
                    <div className="d-flex justify-content-center gap-3">
                        <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="text-primary c-pointer"
                            onClick={() => {
                                setFieldValues({
                                    ...row,
                                    color: row?.status_color?.split("#")?.[1]
                                });
                                setVisible((prev) => ({ ...prev, show: true, row }));
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faTrashCan}
                            className="text-danger c-pointer"
                            onClick={() => { setVisible((prev) => ({ ...prev, delete: true })); setFieldValues(row); }}
                        />
                    </div>
                );
            }
        }
    ];

    useEffect(() => {
        getScreenSummary()
    }, [])

    const getScreenSummary = async () => {
        try {
            setLoader({ grid: true })
            const res = await services.getInvokeRemote("GET", Urls("GETISSUEPRIORITY"));
            if (!res?.body?.error_status) {
                setRowData(_.sortBy(res?.body?.data?.priority_list, "order_number"))
            } else {
                setRowData([])
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader({ grid: false })
        }
    }

    const handleChange = (item, e) => {
        if (item?.name === "status_color") {
            const hexValue = e.value?.startsWith('#') ? e.value : `#${e.value}`;
            setFieldValues((prev) => ({ ...prev, color: e.target.value, status_color: hexValue, isChange: true }));
        } else {
            setFieldValues((prev) => ({ ...prev, [item?.name]: e.target.value, isChange: true }));
        }

    }

    const upsertPriorities = async (isDelete) => {
        try {
            setLoader((prev) => ({ ...prev, btn: true }))

            let names = _.pluck(rowData, "priority_name")?.map(item => item?.toLowerCase()?.trim());
            if (!_.isEmpty(visible?.row)) {
                names = _.filter(names, item => item !== visible?.row?.priority_name?.toLowerCase()?.trim());
            }
            if (!fieldValues?.priority_name?.trim() && !isDelete) {
                showInfo("Info", "Please enter prioritie name.");
                return;
            }
            if (fieldValues?.priority_name?.trim() && names?.includes(fieldValues?.priority_name?.toLowerCase()?.trim()) && !isDelete) {
                showInfo("Info", "This prioritie name is already exist.");
                return;
            }
            if (!fieldValues?.order_number && !isDelete) {
                showInfo("Info", "Please enter order number.");
                return;
            }
            if (!fieldValues?.criticality && !isDelete) {
                showInfo("Info", "Please enter criticality.");
                return;
            }
            if (!fieldValues?.isChange && !isDelete) {
                showInfo("info", "No changes made.");
                return;
            }
            const payload = {
                "priority_id": fieldValues?.priority_id || 0,
                "priority_name": fieldValues?.priority_name || "",
                "status_color": fieldValues?.status_color || "",
                "description": fieldValues?.description || "",
                "criticality": fieldValues?.criticality || "",
                "order_number": fieldValues?.order_number || 0,
                "is_deleted": isDelete || false
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTISSUEPRIORITY"), payload)
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                if (isDelete) {
                    setRowData(prevData => prevData.filter(item => item.priority_id !== fieldValues?.priority_id));
                    setVisible((perv) => ({ ...perv, delete: false }))
                } else {
                    setFieldValues({ isChange: false })
                    setVisible((perv) => ({ ...perv, show: false }))
                    getScreenSummary()
                }

            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("error:", error)
        } finally {
            setLoader((prev) => ({ ...prev, btn: false }))
        }
    }

    return {
        formJson, visible, setVisible, handleChange, fieldValues, columns, rowData, loader, upsertPriorities, setFieldValues, getScreenSummary
    }
}